import type { TFunction } from 'i18next';
import { formatBooleanCriteriaDisplayValue } from './U2000SearchBooleanValueCombo';
import type { CriteriaDynamicDate } from '../../../../tools/u2000DynamicSearchDateUtils';
import { u2000FormatCriteriaDynamicDateDisplay } from '../../../../tools/u2000DynamicSearchDateUtils';

/** Critère date avec opérateur de présence (isNotNull / isNull) — ex. « Inclure les clients supprimés » (BL-0415). */
export function isDatePresenceCriteria(fieldType: string | undefined, conditionName: string | undefined): boolean {
  return fieldType === 'date' && (conditionName === 'isNotNull' || conditionName === 'isNull');
}

/** Libellé i18n pour un opérateur de présence sur colonne date. */
export function formatPresenceCriteriaDisplayValue(conditionName: string, t: TFunction): string {
  if (conditionName === 'isNotNull') {
    return t('lblSearchBooleanTrue');
  }
  if (conditionName === 'isNull') {
    return t('lblSearchBooleanFalse');
  }
  return '';
}

/** Libellé affiché d'un critère actif (liste, puces). */
export function resolveCriteriaDisplayValue(
  field: { type?: string },
  condition: { name: string },
  value: unknown,
  displayValue: string | undefined,
  t: TFunction,
  dynamicDate?: CriteriaDynamicDate,
): string {
  if (field.type === 'boolean') {
    return formatBooleanCriteriaDisplayValue(value, t);
  }
  if (isDatePresenceCriteria(field.type, condition.name)) {
    return formatPresenceCriteriaDisplayValue(condition.name, t);
  }
  if (field.type === 'date' && dynamicDate) {
    const dynamicLabel = u2000FormatCriteriaDynamicDateDisplay(
      { value: String(value ?? ''), dynamicDate, condition },
      t,
    );
    if (dynamicLabel) {
      return dynamicLabel;
    }
  }
  return displayValue ?? (value != null && value !== '' ? String(value) : '');
}
